var _path, _path2, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7552 4.99687C11.199 3.16771 13.801 3.16771 14.2448 4.99687C14.3798 5.55423 14.773 6.01357 15.3028 6.23307C15.8326 6.45257 16.4354 6.40583 16.925 6.10729C18.5323 5.12812 20.3729 6.96771 19.3937 8.57604C19.0956 9.06547 19.049 9.66779 19.2683 10.1973C19.4875 10.7267 19.9463 11.1198 20.5031 11.2552C22.3323 11.699 22.3323 14.301 20.5031 14.7448C19.9458 14.8798 19.4864 15.273 19.2669 15.8028C19.0474 16.3326 19.0942 16.9354 19.3927 17.425C20.3719 19.0323 18.5323 20.8729 16.924 19.8937C16.4345 19.5956 15.8322 19.549 15.3027 19.7683C14.7733 19.9875 14.3802 20.4463 14.2448 21.0031C13.801 22.8323 11.199 22.8323 10.7552 21.0031C10.6202 20.4458 10.227 19.9864 9.69724 19.7669C9.16743 19.5474 8.56464 19.5942 8.075 19.8927C6.46771 20.8719 4.62708 19.0323 5.60625 17.424C5.90436 16.9345 5.95098 16.3322 5.73174 15.8027C5.5125 15.2733 5.05372 14.8802 4.49687 14.7448C2.66771 14.301 2.66771 11.699 4.49687 11.2552C5.05423 11.1202 5.51357 10.727 5.73307 10.1972C5.95257 9.66743 5.90583 9.06464 5.60729 8.575C4.62812 6.96771 6.46771 5.12708 8.07604 6.10625C9.11771 6.73958 10.4677 6.17917 10.7552 4.99687Z",
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7552 4.99687C11.199 3.16771 13.801 3.16771 14.2448 4.99687C14.3798 5.55423 14.773 6.01357 15.3028 6.23307C15.8326 6.45257 16.4354 6.40583 16.925 6.10729C18.5323 5.12812 20.3729 6.96771 19.3937 8.57604C19.0956 9.06547 19.049 9.66779 19.2683 10.1973C19.4875 10.7267 19.9463 11.1198 20.5031 11.2552C22.3323 11.699 22.3323 14.301 20.5031 14.7448C19.9458 14.8798 19.4864 15.273 19.2669 15.8028C19.0474 16.3326 19.0942 16.9354 19.3927 17.425C20.3719 19.0323 18.5323 20.8729 16.924 19.8937C16.4345 19.5956 15.8322 19.549 15.3027 19.7683C14.7733 19.9875 14.3802 20.4463 14.2448 21.0031C13.801 22.8323 11.199 22.8323 10.7552 21.0031C10.6202 20.4458 10.227 19.9864 9.69724 19.7669C9.16743 19.5474 8.56464 19.5942 8.075 19.8927C6.46771 20.8719 4.62708 19.0323 5.60625 17.424C5.90436 16.9345 5.95098 16.3322 5.73174 15.8027C5.5125 15.2733 5.05372 14.8802 4.49687 14.7448C2.66771 14.301 2.66771 11.699 4.49687 11.2552C5.05423 11.1202 5.51357 10.727 5.73307 10.1972C5.95257 9.66743 5.90583 9.06464 5.60729 8.575C4.62812 6.96771 6.46771 5.12708 8.07604 6.10625C9.11771 6.73958 10.4677 6.17917 10.7552 4.99687Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 13,
    r: 3.125,
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 13,
    r: 3.125,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.43605153255d2591a678b2726e6015b7.svg";
export { ForwardRef as ReactComponent };